'use client'

import { WifiOff } from 'lucide-react'
import { useTranslations } from 'next-intl'

import { useNetworkStatus } from '@/hooks/use-network-status'
import { useStatusBarOverDark } from '@/hooks/use-status-bar-over-dark'

/**
 * "Sin conexión" in Encuentro (ALU-115): a slim ink bar across the top, under
 * the status bar, only in the native app and only while offline. Same
 * detection as the classic banner (`useNetworkStatus`). It is a polite live
 * region, so a screen reader hears it when the connection drops.
 */
export function EncuentroNetworkStatusBanner() {
  const t = useTranslations('encuentro.frame')
  const { isOffline, isNative } = useNetworkStatus()
  // Ink bar under the status bar: white clock and battery while it shows (ALU-403)
  useStatusBarOverDark(isOffline && isNative)
  if (!isOffline || !isNative) return null

  return (
    <div
      data-slot="network-status"
      role="status"
      className="fixed inset-x-0 top-0 z-9999 bg-en-ink font-en-sans text-en-primary-ink shadow-en-card pt-safe"
    >
      <p className="flex items-center justify-center gap-2 px-4 py-2 text-en-meta">
        <WifiOff aria-hidden className="size-4 shrink-0" />
        {t('offline')}
      </p>
    </div>
  )
}
